// Local FeatureFlags context — the harness FLAGS-RECIPE (A2).
//
// Replaces `@eventbrite/feature-flag-utils`' `FeatureFlagsProvider`/
// `useFeatureFlags`/`FeatureFlags` (a pure React context over `{[k]:boolean}`,
// NOT Split). This app uses exactly TWO flags, both resolved SERVER-side in
// getServerSideProps and passed down as a plain-boolean map:
//   - enableIaGlobalNav          (header search-bar fork — dissolves into the
//                                 sanctioned GlobalHeader; carried for parity)
//   - launchPrivateCollections   (gates the Private badge on OrganizerUiBanner;
//                                 resolved via splitio-client `getTreatment`)
// Defaults to `{}` (eb-ui threw when unprovided → SSR crash risk).
import React, { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export type FeatureFlags = { [flag: string]: boolean };

const FeatureFlagsContext = createContext<FeatureFlags>({});

export const FeatureFlagsProvider: React.FC<{
    value?: FeatureFlags;
    children: ReactNode;
}> = ({ value, children }) => (
    <FeatureFlagsContext.Provider value={value || {}}>
        {children}
    </FeatureFlagsContext.Provider>
);

export const useFeatureFlags = (): FeatureFlags =>
    useContext(FeatureFlagsContext);
